
function getWhitelabelConfig() {
	switch (document.location.hostname) {
		case "t.mvoice.co.il":
		case "pbx.mvoice.co.il":
			return {
				loginLogo: "https://015pbx.net/local/DMS.png",
				titleSuffix: "mvoice",
				favicon: "https://015pbx.net/favicon.ico"
			};
		case "adeltelecom.com":
		case "www.adeltelecom.com":
			return {
				loginLogo: "https://static.wixstatic.com/media/9fea5c_05bf6f63f4274de9aa12f3b993a583c9~mv2.png/v1/fill/w_254,h_131,al_c,q_85,usm_0.66_1.00_0.01/%D7%9C%D7%95%D7%92%D7%95%20%D7%90%D7%93%D7%9C%20%D7%92%D7%A8%D7%95%D7%A4-01.png",
				titleSuffix: "ADEL Telecom",
				favicon: "https://015pbx.net/local/PCB.ico"
			};
		case "www.mvoice.io":
		case "mvoice.io":
			return {
				loginLogo: "https://pbx.mvoice.co.il/local/mvoice.png",
				titleSuffix: "mvoice",
				favicon: "https://015pbx.net/favicon.ico"
			};
		case "epbx.cloud":
		case "www.epbx.cloud":
			return {
				loginLogo: "",
				titleSuffix: "epbx",
				favicon: "https://015pbx.net/favicon.ico"
			};

		default:
			return {
				loginLogo: "/callcenter/images/logo-015.png",
				titleSuffix: "015 Cloud",
				favicon: "https://www.015.cloud/callcenter/fav-015.png"
			};
	}
}

export function setWhitelabelConfig() {
	window.whitelabelConfig = getWhitelabelConfig();
	if (window.whitelabelConfig.favicon) {
		(function() {
			var link = document.querySelector("link[rel*='icon']") || document.createElement("link");
			link.type = "image/x-icon";
			link.rel = "shortcut icon";
			link.href = window.whitelabelConfig.favicon;
			document.getElementsByTagName("head")[0].appendChild(link);
		})();
	}
};
